import { Box, Grid, Chip, Avatar, Typography } from "@mui/material"
import { useAppSelector, useAppDispatch } from "../../../../../../../hooks/store-hooks";
import { unselectListaCbo } from "../../../../../../../../application/states/geo-veles/lista-cbo";
import { IListaCbo } from "../../../../../../../../application/models/geo-veles/IListaCbo";
import { removeListaCBOFilterState } from "../../../../../../../../application/states/geo-veles";

export const ListaCBOFilterPreview = () => {
    const dispatch = useAppDispatch();

    // State
    const { selectedListasCbo } = useAppSelector((state) => state.listaCbo);
    const { filtrosSelecionados } = useAppSelector((state) => state.projetos);
    const { listasCbo: todasAsListasCbo } = useAppSelector((state) => state.listaCbo);

    const handleRemoveLista = (lista: IListaCbo) => {
        dispatch(unselectListaCbo({ lista }));
        dispatch(removeListaCBOFilterState({
            idVelesGeoListaCBO: lista.IdVelesGeoListaCBO
        }));
    };

    const listasSelecionadasCompletas = selectedListasCbo.length > 0
        ? selectedListasCbo
        : (filtrosSelecionados?.listasCbo || [])
            .map((id) => {
                const lista = todasAsListasCbo.find(
                    (lista) => String(lista.IdVelesGeoListaCBO) === String(id)
                );
                return lista;
            })
            .filter((lista): lista is IListaCbo => lista != null);

    if (listasSelecionadasCompletas.length === 0) {
        return null;
    }

    return (
        <>
            <Box mt={2}>
                <Grid container spacing={3}>
                    <Grid item xs={12}>
                        <Typography color="primary" fontWeight="bold" gutterBottom>
                            Listas de Ocupações Selecionadas:
                        </Typography>
                    </Grid>
                    {listasSelecionadasCompletas.map((lista) => (
                        <Grid item key={lista.IdVelesGeoListaCBO}>
                            <Chip
                                sx={{
                                    height: "auto",
                                    "& .MuiChip-label": {
                                        transition: '0.1s all',
                                        display: "block",
                                        whiteSpace: "normal",
                                        padding: "10px 15px",
                                        fontWeight: "bold",
                                    },
                                }}
                                color="primary"
                                onDelete={() => handleRemoveLista(lista)}
                                avatar={
                                    <Avatar sx={{
                                        "&": {
                                            transition: '0.1s all'
                                        },
                                        "&:hover": {
                                            color: "secondary.main",
                                            cursor: 'default'
                                        }
                                    }}>
                                    </Avatar>
                                }
                                label={lista.Nome.toUpperCase()}
                            />
                        </Grid>
                    ))}
                </Grid>
            </Box>
        </>
    );
}